import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { API_BASE_URL } from 'shared';

export interface Address {
  id: number;
  full_name: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  is_default: boolean;
}

export interface CreateAddressPayload {
  full_name: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zip_code: string;
  country?: string;
  is_default?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AddressService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(API_BASE_URL);

  private readonly _addresses = signal<Address[]>([]);
  readonly addresses = this._addresses.asReadonly();

  load(): void {
    this.http
      .get<Address[]>(`${this.base}/account/addresses`, { withCredentials: true })
      .subscribe({
        next: (list) => this._addresses.set(list),
        error: () => this._addresses.set([])
      });
  }

  create(payload: CreateAddressPayload) {
    return this.http.post<Address>(`${this.base}/account/addresses`, payload, {
      withCredentials: true
    });
  }
}
